export enum ContextEnum {
    OfficeAddin = "OfficeAddin",
    ResourceUserRestriction ="Resource.UserRestriction"
}

export const allContextKeys: string[] = Object.values(ContextEnum);